<template>
  <div class="content">
    <h1 class="title">{{ $t("products.title") }}</h1>
    <div>
      <div class="table">
        <v-data-table
          v-if="!isLoading"
          :headers="tableHeaders"
          :items="products"
          disable-sort
          hide-default-footer
          :items-per-page="-1"
          class="elevation-0"
        >
          <template v-slot:[`item.thumbnail`]="{ item }">
            <div class="thumbnail">
              <img
                v-if="item.selectable.thumbnail_base64"
                :src="item.selectable.thumbnail_base64"
              />
              <v-icon v-else icon="mdi-image-off-outline"></v-icon>
            </div>
          </template>
          <template v-slot:[`item.cover_image`]="{ item }">
            <div class="cover-image">
              <img
                v-if="item.selectable.cover_image_base64"
                :src="item.selectable.cover_image_base64"
              />
              <v-icon v-else icon="mdi-image-off-outline"></v-icon>
            </div>
          </template>
          <template v-slot:[`item.can_sold`]="{ item }">
              <div class="d-flex justify-center align-center">
                <v-icon v-if="item.selectable.can_sold" color="green">mdi-check-circle</v-icon>
                <v-icon v-else color="red">mdi-close-circle</v-icon>
              </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-menu>
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  variant="text"
                  icon="mdi-pencil"
                ></v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(menuItem, index) in filteredMenuItems"
                  :key="index"
                  :value="index"
                  :append-icon="menuItem.icon"
                  @click="menuItem.action(item.raw)"
                >
                  <v-list-item-title>
                    {{ menuItem.title }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:no-data>
            <Vue3Lottie
              :animationData="NoDataLottie"
              :height="200"
              :width="200"
            />
            <div class="pb-5 table-no-data">
              <h3>{{ $t("tableNoDataTitle") }}</h3>
              <p>{{ $t("tableNoDataDesc") }}</p>
            </div>
          </template>
          <template v-slot:bottom>
            <div class="botSide">
              <v-row align="center" justify-sm="end" justify="center" class="px-2">
                <v-col cols="12" xs="12" lg="3" md="4" sm="6">
                  <v-row align="center" justify="end"
                    ><div class="pr-2 pageSelectorLabel">
                      {{ $t("anomaly.tableFooterText") }}
                    </div>
                    <v-select
                      v-model="limit"
                      hide-details
                      @update:model-value="handleFilter(false)"
                      :items="pageSizes"
                      class="pageSelector pl-5"
                    ></v-select>
                    <div class="pl-2">
                      {{ displayRange }}
                    </div>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  lg="3"
                  md="4"
                  sm="5"
                  class="pl-1 pr-1 pagination"
                >
                  <!-- TODO: Pagination when we join the api -->
                  <v-pagination
                    v-model="page"
                    :length="pageCount"
                    rounded="circle"
                    :total-visible="1"
                    show-first-last-page="true"
                    @update:model-value="handleFilter(true)"
                  ></v-pagination>
                </v-col>
              </v-row>
            </div>
          </template>
        </v-data-table>
        <v-card v-else class="loading">
          <v-progress-circular
            v-if="isLoading"
            size="73.5"
            indeterminate
            class="loading-circle"
          ></v-progress-circular>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue3Lottie } from "vue3-lottie";
import NoDataLottie from "@/assets/lotties/nodatalottie.json";
import CreateProductModalComponent from "@/components/global/modalComponents/createProductModal/CreateProductModalComponent";
import { useToast } from "vue-toastification";
const toast = useToast();
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Porducts",
  components: {
    Vue3Lottie,
  },
  data() {
    return {
      NoDataLottie,
      isLoading: true,
      menuItems: [
        {
          type: "createProduct",
          icon: "mdi-folder-plus-outline",
          title: this.$t("products.table.actions.edit"),
          action: (product) => this.handleEdit(product),
          sa_can_see: true,
        },
        {
          type: "editProduct",
          icon: "mdi-pencil",
          title: this.$t("products.table.actions.settings"),
          action: (product) => this.handleCapacitySettings(product),
          sa_can_see: false,
        },
      ],
      page: 1,
      products: undefined,
      total: undefined,
      limit: undefined,
      pageSizes: [10, 25, 50, 100],
      languages: undefined,
    };
  },
  mounted() {
    this.getProducts();
    this.getLanguages()
      .then((res) => {
        this.languages = res.list;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    ...mapActions({
      productList: "products/productList",
      updatePorduct: "products/updateProduct",
      uploadProductImages: "products/uploadProductImages",
      getLanguages: "settings/getLanguages",
    }),
    getProducts() {
      this.productList()
        .then((response) => {
          this.products = response.list;
          this.total = response.total;
          this.limit = response.limit;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    handleEdit(product) {
      this.emitter.emit("showComponentModalModal", {
        bind: {
          is: CreateProductModalComponent,
          product: product,
          languages: this.languages,
        },
        on: {
          saveProduct: (props, descriptions, bodyFormData) => {
            this.isLoading = true;
            const requestBody = {
              language_datas: descriptions,
              can_sold: props.can_sold,
              layout_id: props.layout_id,
              tag_id: props.tag_id
            };
            let payload = {};
            payload.requestBody = requestBody;
            payload.productId = props.id;
            this.updatePorduct(payload)
              .then(() => {
                this.uploadProductImages(bodyFormData)
                  .then(() => {
                    toast.success(this.$t("products.successSave"));
                    this.getProducts();
                  })
                  .catch((e) => {
                    console.log(e);
                    this.emitter.emit("closeModal");
                  });

                this.emitter.emit("closeModal");
              })
              .catch(() => {
                this.isLoading = false;
                this.emitter.emit("closeModal");
              });
          },
          closeModal: () => {
            this.emitter.emit("closeModal");
          },
        },
      });
    },
    handleCapacitySettings(product) {
      this.$router.push(`/capacity-settings/${product.id}`);
    },
    handleFilter(hasPage) {
      const requestBody = {
        limit: this.limit,
        page: hasPage ? this.page : 1,
      };
      this.isLoading = true;
      this.productList(requestBody)
        .then((response) => {
          this.products = response.list;
          this.total = response.total;
          this.limit = response.limit;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  computed: {
    ...mapGetters({ loggedInUser: "users/loggedInUser" }),
    isSuperAdmin() {
      return this.loggedInUser && this.loggedInUser.role === 0;
    },
    filteredMenuItems() {
      return this.isSuperAdmin
        ? this.menuItems.filter((menuItem) => menuItem.sa_can_see)
        : this.menuItems;
    },
    pageCount() {
      return Math.ceil(this.total / this.limit);
    },
    displayRange() {
      const start = (this.page - 1) * this.limit + 1;
      const end = Math.min(start + this.limit - 1, this.total);
      return `${start}-${end} of ${this.total}`;
    },
    tableHeaders() {
      return [
        {
          title: this.$t("products.table.headers.id"),
          key: "id",
          align: "left",
          sortable: false,
        },
        {
          title: this.$t("products.table.headers.thumbnail"),
          key: "thumbnail",
          align: "left",
          sortable: false,
        },
        {
          title: this.$t("products.table.headers.coverImage"),
          key: "cover_image",
          align: "left",
          sortable: false,
        },
        {
          title: this.$t("products.table.headers.groupName"),
          key: "productgroup.name",
          align: "left",
          sortable: false,
        },
        {
          title: this.$t("products.table.headers.productName"),
          key: "name",
          align: "left",
          sortable: false,
        },
        {
          title: this.$t("products.table.headers.canSold"),
          key: "can_sold",
          align: "center",
          sortable: false,
        },
        {
          title: this.$t("products.table.headers.actions"),
          key: "actions",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.thumbnail {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 32px;
  }
  i {
    color: #e1e0e0;
    font-size: 30px;
  }
}
.cover-image {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 32px;
  }
  i {
    color: #e1e0e0;
    font-size: 30px;
  }
}
</style>
